export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';

export const USER_UPDATE_DETAILS_REQUEST = 'USER_UPDATE_DETAILS_REQUEST';
export const USER_UPDATE_DETAILS_SUCCESS = 'USER_UPDATE_DETAILS_SUCCESS';
export const USER_UPDATE_DETAILS_FAIL = 'USER_UPDATE_DETAILS_FAIL';
export const USER_UPDATE_DETAILS_RESET = 'USER_UPDATE_DETAILS_RESET';

export const USERS_ADMIN_LIST_REQUEST = 'USERS_ADMIN_LIST_REQUEST';
export const USERS_ADMIN_LIST_SUCCESS = 'USERS_ADMIN_LIST_SUCCESS';
export const USERS_ADMIN_LIST_FAIL = 'USERS_ADMIN_LIST_FAIL';
